import {PerFormaAPIService, ModuleDto} from "src/app/services/pfapi.service";
import {Injectable} from "@angular/core";
import {lastValueFrom} from "rxjs";
import {AiStatuses} from "src/app/models/performa-enums";

@Injectable({
    providedIn: "root"
})
export class PerformaModulesService {
    // enabled module names, kept synchronous for consumers that read it directly (.includes/.some)
    public features: string[] = [];
    private _initialized = false;
    private _modules: ModuleDto[] | null = null;

    constructor(private readonly api: PerFormaAPIService) {}

    // cached fetch of all modules; also populates the synchronous `features` list of enabled names
    Modules = async (): Promise<ModuleDto[]> => {
        if (!this._initialized) {
            this._modules = (await lastValueFrom(this.api.getApiSystemModules())) || [];
            this.features = this._modules.filter(m => m.IsEnabled).map(m => m.Name || "");
            this._initialized = true;
        }

        return this._modules || [];
    };

    // clears the cached modules so the next login refetches, replacing the previous user's set.
    reset(): void {
        this._initialized = false;
        this._modules = null;
        this.features = [];
    }

    // current per-instance AI opt-in status (Off / Requested / Active). fetched fresh each call so the
    // AI settings page reflects state changes immediately after enabling.
    AiStatus = async (): Promise<number> => {
        return (await lastValueFrom(this.api.getApiConfigureAiStatus())) as number;
    };

    AiRequested = async (): Promise<boolean> => {
        return (await this.AiStatus()) === AiStatuses.Requested;
    };

    AiEnabled = async (): Promise<boolean> => {
        return (await this.AiStatus()) === AiStatuses.Active;
    };

    // called from APP_INITIALIZER so `features` is populated before components read it synchronously
    async init(): Promise<void> {
        if (!localStorage.getItem("pf_token")) return;
        try {
            await this.Modules();
        } catch {
            // unauthenticated/expired — features stay empty; guard/interceptor handle redirect
        }
    }
}
